<div class="data-grid">
    <kendo-grid
        [data]="query | async"
        [loading]="isLoading"
        [skip]="state.skip"
        [pageSize]="state.take"
        scrollable="virtual"
        [rowHeight]="36"
        [height]="750"
        (pageChange)="pageChange($event)"
        (excelExport)="onExcelExport($event)"
    >

        <ng-template kendoGridToolbarTemplate>

            <button class="export-to-excel-button" kendoGridExcelCommand>
                <img
                    class="ms-icon"
                    src="assets/icons/excel-icon.svg"
                    style="width: 35px;
                            height: 35px;
                            vertical-align: middle;">
                {{ 'ExportToExcel' | translate: {Default: "Export to Excel"} }}
            </button>

            <div class="filters-container">
                <filter-control [categories]="filterCategories" (callback)="filterCallback($event)"></filter-control>
            </div>

        </ng-template>

        <kendo-grid-column
            *ngFor="let col of columns"
            [field]="col.field"
            [title]="col.title"
            [width]="300"
        ></kendo-grid-column>

        <ng-template kendoGridNoRecordsTemplate>
            <div>{{ 'Common-NoRecords' | translate: {Default: "No records available"} }}</div>
        </ng-template>

        <kendo-grid-excel
            fileName="PendingTimeOffReport.xlsx"
            [fetchData]="allData"
        ></kendo-grid-excel>

        <!--        <kendo-grid-excel fileName="PendingTimeOffReport.xlsx"></kendo-grid-excel>-->
    </kendo-grid>
</div>
